import { render, staticRenderFns } from "./BuscarVariacao.vue?vue&type=template&id=d7125e1c&scoped=true&"
import script from "./BuscarVariacao.vue?vue&type=script&lang=js&"
export * from "./BuscarVariacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7125e1c",
  null
  
)

export default component.exports